import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import $ from 'jquery';
import Vas from '../../Vas';
import { PagingTable,Loading } from 'component-lib';
import { DateTimeHelper }  from 'utils-lib';
import { RequestAjaxClass, CustomerModel } from 'models-lib';

class Customers extends Component{

    constructor(props)
    {
        super(props);
        this.state = {};
        this.state.Limit = 10;
        this.state.Start = 0;
        this.Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
        this.CustomerModel = new CustomerModel([this]);
    }

    componentWillMount(){
        ReactDOM.render(<Loading modal={true} />,document.getElementById('popupContainer'));
        this.Request.setApiUrl(Vas.ApiUrl);
        this.Request.setApiKey(Vas.ApiKey);
        this.Request.setAuth(true);
        this.Request.setErrorHandler(()=>{
            ReactDOM.unmountComponentAtNode(document.getElementById('popupContainer'));
        });
        this.CustomerModel.SetRequest(this.Request);
    }

    componentDidMount()
    {

        this.didMount();
    }

    componentDidUpdate(){
    
        this.didMount();
    }

    Update(observer){
        let me = this;
        this.setState({},()=>{
            if(observer === "Customers"){
                let customers = [];
                if (this.CustomerModel.Customers)
                {         
                    this.CustomerModel.Customers.forEach(function(value) {
                        let customer = {};
                        customer.Id = value.Id;
                        customer.Name1 = value.Name1;
                        customer.Name2 = value.Name2;
                        customer.Name3 = value.Name3;
                        customer.Gender = value.Gender;
                        customer.HouseNumber = value.HouseNumber;
                        customer.DateOfBirth = DateTimeHelper.FormatToShortDateString(DateTimeHelper.StringToDate(value.DateOfBirth,true,localStorage.getItem('vas_language')));
                        customer.Street = value.Street;
                        customer.Vid = value.Vid;
                        customer.PostCode = value.PostCode;
                        customer.City = value.City;
                        customer.CustomerNumber = value.CustomerNumber;
                        customer.Client = value.Client;
                        customer.Vu = value.Vu;
                        customer.Email = value.Email;
                        customers.push(customer);
                    });

                    localStorage.setItem('csvDataContent',JSON.stringify(customers));
                }

                $("#LoadingIcon").removeClass().addClass('hide');

                if (me.refs.table){
                    me.refs.table.setState({ Data: customers, Count: this.CustomerModel.Count, Limit: this.CustomerModel.Limit, Start: this.CustomerModel.Start, End: this.CustomerModel.Start+customers.length });
                }
                ReactDOM.unmountComponentAtNode(document.getElementById('popupContainer'));
            }
        });
    }

    load(sendData){

        localStorage.setItem("SendData", sendData);

        this.CustomerModel.GetCustomers(sendData,null,null,"name1");
        
        $("#LoadingIcon").removeClass().addClass('loaderSmall');
    }

    didMount(){
       $("#HeaderTitle").html(Vas.Resources.Labels["Customers"]);
    }

    //Methode to generate a Guid
    //necessary to show Guid in Browser Addressline
    //otherwise the CustomerNumber is shown there
    //Problem: Search by changing CustomerNumber in Browser Addressline
    getGuid() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
          return v.toString(16);
        });
    }

    loadCustomer(id){

        localStorage.setItem("Number_CurrentCustomer", id);

        Vas.GetView("CustomerCardData",{ Id:this.getGuid() },true);
    }

    render(){

        return (
          <div
            className={"form"}
            style={{ width: '850px' }}>
            <table>
              <thead>
                <tr>
                  <th style={{ width:'100%' }}></th>
                  <th><div 
                    id={"LoadingIcon"}
                    className={'hide'} ></div></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td >
            <PagingTable
            ErrorHandlingPage={(error)=>{Vas.ErrorHandling(error);}}
              ref="table"
              SearchCol={"Name1"}
              TableReference={this}
              DataBaseTable={"B2Kunde"} 
              Border={true}
              Search={true}
              Selectable={false}
              Limit={this.state.Limit}
              Start={this.state.Start}
              End={this.state.End}
              ParamCustomerCategory={"Abo"}
              Count={this.state.Count} 
              Columns={[Vas.Resources.Labels["CustomerNr"],Vas.Resources.Labels["FirstName"],Vas.Resources.Labels["Name"], Vas.Resources.Labels["DateOfBirth"],
                       Vas.Resources.Labels["City"],Vas.Resources.Labels["PLZ"]]} 
              Keys={["CustomerNumber","Name2","Name1","DateOfBirth","City","PostCode"]} 
              Data={this.state.Data}
              CSVTableName={Vas.Resources.Labels["Customers"]}
              CSV={true}
              CSVController={"/Customers"}
              Token={localStorage.getItem('vas_token')}
              AppURL={Vas.ApplicationUrl}
              ApiURL={Vas.ApiUrl}
              ApiKey={Vas.ApiKey}
              LabelPage={Vas.Resources.Labels["Page"]}
              LabelOf={Vas.Resources.Labels["Of"]}
              LabelCountPerPage={Vas.Resources.Labels["CountPerPage"]}
              Width={'100%'} 
              NewApi={true}
              RowOnClick={(id)=>{this.loadCustomer(id);}}
              IdColoumn={"CustomerNumber"}
              SearchLimit={7000}
              ExtendShownResultsOnPage={true}
              ShowAllOnOnePage={true}
                />
                 </td>
                </tr>
              </tbody>
            </table>
          </div> 
        );
    }
}
export default Customers;
